import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiConfig } from "../../../../ppm-app/shared/services/api/config.api";

@Injectable()
export class BulkUploadService {
  constructor(private httpClient: HttpClient) {}

  uploadExcelForm(body, token) {
    let headers = new HttpHeaders({
      "X-WEB-CLIENT": token,
    });
    const url =
      "sit/api/eazypension-member-service/v1/member/upload?language=en_us&channel=mobile";
    return this.httpClient.post(ApiConfig.baseURL + url, body, {
      headers: headers,
    });
  }

  generateXclient() {
    const url =
      "sit/api/eazypension-auth-service/v1/token/generateXClient?language=en_us&channel=mobile";
    const body = "";
    return this.httpClient.post(ApiConfig.baseURL + url, body, {
      headers: ApiConfig.requestOptionsHeader,
    });
  }
}
